import Input from "@/components/common/Input";
import {getBoardDetailStore} from "@/store/admin/BoardDetailStore";
import {getOrderNumberAsc} from "@/utils";

export const getNewsSubscribeList = () => [
    {
        width: "50px",
        type: "checkbox",
        render: (rowKey, _, __, ___, checkType) =>
            <div className="flex al-center jc-center">
                <Input
                    inputType="checkbox"
                    id={`list-check-${rowKey}`}
                    checked={getBoardDetailStore().searchBaseStore.getSingleChecked(rowKey, checkType)}
                    onChange={(e) => {
                        getBoardDetailStore().searchBaseStore.setSingleChecked(e.target.checked, rowKey, checkType);
                    }}
                />
            </div>
    },
    {
        label: "번호",
        width: "50px",
        render: (rowKey, _, offset, count) =>
            getOrderNumberAsc(rowKey, offset, 50),
    },
    {
        label: "구독 이메일",
        render: (_, row) => {
            return(
                <>{row}</>
            )
        }
    },
]